import React, { useState } from 'react';
import InputField from '../../../components/InputField';
import { Modal } from 'react-bootstrap';
import SimpleReactValidator from 'simple-react-validator';
import swal from 'sweetalert';
import { useRef } from 'react';
import axiosInstance from '../../../services/AxiosInstance';

const ForgetPassword = ({ setShowFP }) => {

    const [forgetPassword, setForgetPassword] = useState(true);
    const [verifyOtp, setVerifyOtp] = useState(false);
    const [input, setInput] = useState({ match_pass: false });
    const [user, setUser] = useState();
    const [passLength, setPassLength] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [, forceUpdate] = useState();
    const [newPass, setNewPass] = useState(false);
    const [conPass, setConPass] = useState(false);
    const simpleValidator = useRef(new SimpleReactValidator());

    const handleForgetPassword = () => {
        if (!(simpleValidator.current.allValid())) {
            setPassLength(false);
            simpleValidator.current.showMessages();
            forceUpdate(1);
        } else if (input?.password.length < 6) {
            setPassLength(true);
            setInput({ ...input, "match_pass": false });
        } else if (!(input?.password === input?.con_pass)) {
            setPassLength(false);
            setInput({ ...input, "match_pass": true });
        } else if (+(input && input?.verify_otp) === +(user && user?.[0]?.emailOTP)) {
            setPassLength(false);
            setInput({ ...input, "match_pass": false });
            axiosInstance(
                "reset_password/", {
                method: 'PUT',
                data: {
                    password: input?.password,
                    email: input?.email
                },
            }).then(res => {
                swal("", `Password updated successfully`, "success", { button: "OK!", });
                setInput({});
                setShowFP(false);
            }).catch(err => {
                swal("", Object.values(err.response.data).join(', '), "error", { button: "OK!", });
            })
        } else if (!(otpSent)) {
            axiosInstance(
                "verify-email/", {
                method: 'POST',
                data: { email: input?.email }
            }).then(res => {
                setForgetPassword(false);
                setVerifyOtp(true);
                getUser();
            }).catch(err => {
                setForgetPassword(false);
                swal("", Object.values(err.response.data).join(', '), "error", { button: "OK!" });
            })
            setOtpSent(true);
        } else {
            swal({
                text: "Invalid OTP",
                icon: "error",
                dangerMode: true,
            }).then(willDelete => {
                if (willDelete) setVerifyOtp(true);
            });
        }
    }

    const getUser = () => {
        axiosInstance(
            `user/?search=${input?.email}`, {
            method: 'GET',
            data: {},
        }).then(res => {
            setUser(res.data.results);
        }).catch(err => {
            swal("", `${JSON.stringify(err?.response?.data)}`, { button: "Try Again!", });
        })
    }

    const handleClose = () => {
        setInput({});
        setForgetPassword(false);
        setShowFP(false);
    }

    const handleChangePassword = () => {
        setVerifyOtp(false);
        handleForgetPassword();
    }

    const handleChange = (e) => {
        setInput({ ...input, [e.target.name]: e.target.value });
    }

    return (
        <>
            <Modal className="modal fade modal-bx-info editor" show={forgetPassword} onHide={setForgetPassword}>
                <div className="my-0" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="EducationModalLongTitle">Forget Password</h5>
                            <button type="button" className="close" onClick={handleClose}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-12 col-md-12">
                                    <div className="form-group">
                                        <InputField
                                            label="E-mail"
                                            name="email"
                                            value={input?.email}
                                            onChange={(e) => handleChange(e)}
                                            required={true}
                                            placeholder="Enter Email Address"
                                        />
                                        <span className="text-danger">
                                            {simpleValidator.current.message('email', input?.email, 'required|email')}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12" style={{ marginBottom: "1.5rem" }}>
                                    <label className='mb-0'>New Password *</label>
                                    <div className="input-group">
                                        <InputField
                                            name="password"
                                            type={`${newPass ? "text" : "password"}`}
                                            value={input?.password}
                                            onChange={(e) => handleChange(e)}
                                            required={true}
                                            className="form-control change-password"
                                            placeholder="Enter New Password"
                                            onKeyPress={(e) => e.target.value.length >= 30 && e.preventDefault()}
                                        />
                                        <div className="change-password input-group-text" style={{ cursor: "pointer" }} onClick={() => setNewPass(!newPass)}>
                                            <i className="fa fa-eye" />
                                        </div>
                                    </div>
                                    <span className="text-danger">
                                        {simpleValidator.current.message('password', input?.password, 'required')}
                                    </span>
                                    {passLength && <div className="text-danger fs-12">"Password must be minimum 6 characters"</div>}
                                </div>
                                <div className="col-lg-12 col-md-12">
                                    <label className='mb-0'>Confirm Password *</label>
                                    <div className="input-group">
                                        <InputField
                                            name="con_pass"
                                            type={`${conPass ? "text" : "password"}`}
                                            value={input?.con_pass}
                                            onChange={(e) => handleChange(e)}
                                            required={true}
                                            placeholder="Enter Confirm Password"
                                            className="form-control change-password"
                                            onKeyPress={(e) => e.target.value.length >= 30 && e.preventDefault()}
                                        />
                                        <div className="change-password input-group-text" style={{ cursor: "pointer" }} onClick={() => setConPass(!conPass)}>
                                            <i className="fa fa-eye" />
                                        </div>
                                    </div>
                                    <span className="text-danger">
                                        {simpleValidator.current.message('Confirm password', input?.con_pass, 'required')}
                                    </span>
                                    {
                                        input?.match_pass &&
                                        <span className="text-danger font-weight-bold">
                                            Confirm Password doesn't match with New Password.
                                        </span>
                                    }
                                    {passLength && <div className="text-danger fs-12">"Password must be minimum 6 characters"</div>}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="site-button" onClick={handleClose}>Cancel</button>
                            <button
                                type="button"
                                className="site-button"
                                onClick={() => handleForgetPassword()}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal className="modal fade modal-bx-info editor" show={verifyOtp} onHide={setVerifyOtp}>
                <div className="my-0" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="EducationModalLongTitle">Forget Password</h5>
                            <button type="button" className="close" onClick={() => setVerifyOtp(false)}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-12 col-md-12">
                                    <div className="form-group">
                                        <InputField
                                            label="Verify OTP"
                                            name="verify_otp"
                                            type="number"
                                            value={input?.verify_otp}
                                            onChange={(e) => handleChange(e)}
                                            required={true}
                                            placeholder="Enter OTP"
                                            onKeyPress={e => e.target.value.length >= 5 && e.preventDefault()}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="site-button" onClick={() => setVerifyOtp(false)}>Cancel</button>
                            <button
                                type="button"
                                className="site-button"
                                onClick={() => handleChangePassword()}
                                disabled={!input?.verify_otp ? true : false}
                                style={{ backgroundColor: input?.verify_otp ? "#1d46f5" : "#8b99d5", cursor: input?.verify_otp ? "pointer" : "not-allowed" }}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ForgetPassword;